const theme = {
	primary       : "#000",
	base_font     : "RL2, sans-serif",
	base_bold_font: "RL2, sans-serif",
	body_bg       : "",
	spinner       : "#00CF5D",
};

export default theme;
